import React, { useState , useEffect} from 'react';
import { Box, Typography, TextField, Button, Alert } from '@mui/material';
import { addFeedback } from '../../../services/database/database_service';
import { useLanguage } from "../../../services/localization/LanguageContex";



function PublicFeedbackScreen() {
  const{ language } = useLanguage();
  const [feedback, setFeedback] = useState('');
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');


  useEffect(() => {
    window.scrollTo(0, 0);
    // window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMsg('');
    setErrorMsg('');

    try {
      const data = { feedback };
      await addFeedback(data);
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setSuccessMsg('Thank you for your feedback!');
      setFeedback('');
    } catch (error) {
      setErrorMsg(error.message);
    } finally {
      setLoading(false);
    }
  };
  // console.log(feedback)

  return (
    <Box sx={{ p: 6, pt: 2 }}>
      <Typography variant="h4" gutterBottom align="center" sx={{ mb: 3 }}>
        {language === 'dz' ? 'བསམ་ལན།' : 'Feedback'}
      </Typography>

      <Typography variant="body1" align="center" sx={{ mb: 4 }}>
  {language === 'dz'?'':'We value your feedback! Please share your thoughts or suggestions to help us improve.'}
  
     </Typography>


      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          maxWidth: 600,
          mx: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <TextField
          label={language === 'dz' ? 'བསམ་ལན།' : 'Feedback'}
          variant="outlined"
          multiline
          rows={10}
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          required
        />
        <Button type="submit" variant="contained" disabled={loading}
        sx={{
          backgroundColor: "rgba(27, 39, 58, 0.91)",
          color: "white",
          "&:hover": {
            backgroundColor: "#1b273a", // Slightly darker on hover
          },
        }}
        >
            {loading
            ? language === 'dz' ? 'བཙུགས་ནི་འབད་དོ...' : 'Submitting...'
            : language === 'dz' ? 'བཙུགས་གནང་།' : 'Submit'}
        </Button>

        {successMsg && <Alert severity="success">{successMsg}</Alert>}
        {errorMsg && <Alert severity="error">{errorMsg}</Alert>}
      </Box>
    </Box>
  );
}

export default PublicFeedbackScreen;
